import { Search24Regular } from '@/components/Icon'
import { Box, InputBase } from '@mui/material'
import styles from './SearchRow.module.scss'

const searchWrapSx = { backgroundColor: 'var(--app-bg-panel)' }

function SearchRow({ value, onChange, placeholder = 'Search', sx = {} }) {
  return (
    <Box component="label" className={styles.searchWrap} sx={[searchWrapSx, sx, searchWrapSx]}>
      <Search24Regular className={styles.searchIcon} />
      <InputBase
        className={styles.searchInputBase}
        value={value}
        onChange={(event) => onChange?.(event.target.value)}
        placeholder={placeholder}
        slotProps={{
          input: {
            'aria-label': placeholder,
            className: styles.searchInput,
          },
        }}
      />
    </Box>
  )
}

export default SearchRow
